function newImage(arg) {
    if (document.images) {
        rslt = new Image();
        rslt.src = arg;
        return rslt;
    }
}

function changeImages() {
    if (document.images && (preloadFlag == true)) {
        for (var i = 0; i < changeImages.arguments.length; i += 2) {
            document[changeImages.arguments[i]].src = changeImages.arguments[i + 1];
        }
    }
}

var preloadFlag = false;
function preloadImages() {
    if (document.images) {
        map_mk_01_17_over = newImage("Content/images/map_images/map_mk_01-17_over.gif");
        map_mk_01_04_over = newImage("Content/images/map_images/map_mk_01-04_over.gif");
        map_mk_01_18_over = newImage("Content/images/map_images/map_mk_01-18_over.gif");
        map_mk_01_05_over = newImage("Content/images/map_images/map_mk_01-05_over.gif");
        map_mk_01_19_over = newImage("Content/images/map_images/map_mk_01-19_over.gif");
        map_mk_01_06_over = newImage("Content/images/map_images/map_mk_01-06_over.gif");
        map_mk_01_07_over = newImage("Content/images/map_images/map_mk_01-07_over.gif");
        map_mk_01_08_over = newImage("Content/images/map_images/map_mk_01-08_over.gif");
        map_mk_01_09_over = newImage("Content/images/map_images/map_mk_01-09_over.gif");
        map_mk_01_01_over = newImage("Content/images/map_images/map_mk_01-01_over.gif");
        map_mk_01_10_over = newImage("Content/images/map_images/map_mk_01-10_over.gif");
        map_mk_01_20_over = newImage("Content/images/map_images/map_mk_01-20_over.gif");
        map_mk_01_21_over = newImage("Content/images/map_images/map_mk_01-21_over.gif");
        map_mk_01_02_over = newImage("Content/images/map_images/map_mk_01-02_over.gif");
        map_mk_01_22_over = newImage("Content/images/map_images/map_mk_01-22_over.gif");
        map_mk_01_23_over = newImage("Content/images/map_images/map_mk_01-23_over.gif");
        map_mk_01_24_over = newImage("Content/images/map_images/map_mk_01-24_over.gif");
        map_mk_01_25_over = newImage("Content/images/map_images/map_mk_01-25_over.gif");
        map_mk_01_11_over = newImage("Content/images/map_images/map_mk_01-11_over.gif");
        map_mk_01_26_over = newImage("Content/images/map_images/map_mk_01-26_over.gif");
        map_mk_01_12_over = newImage("Content/images/map_images/map_mk_01-12_over.gif");
        map_mk_01_27_over = newImage("Content/images/map_images/map_mk_01-27_over.gif");
        map_mk_01_13_over = newImage("Content/images/map_images/map_mk_01-13_over.gif");
        map_mk_01_28_over = newImage("Content/images/map_images/map_mk_01-28_over.gif");
        map_mk_01_14_over = newImage("Content/images/map_images/map_mk_01-14_over.gif");
        map_mk_01_29_over = newImage("Content/images/map_images/map_mk_01-29_over.gif");
        map_mk_01_15_over = newImage("Content/images/map_images/map_mk_01-15_over.gif");
        map_mk_01_03_over = newImage("Content/images/map_images/map_mk_01-03_over.gif");
        map_mk_01_30_over = newImage("Content/images/map_images/map_mk_01-30_over.gif");
        map_mk_01_16_over = newImage("Content/images/map_images/map_mk_01-16_over.gif");
        preloadFlag = true;
    }
}